import React, { useState, useContext } from "react";
import {
  AppBar,
  Toolbar,
  Tooltip
} from "@material-ui/core";
import Info from "@material-ui/icons/InfoOutlined";
import { ReactComponent as FoundryLogo } from "../../assets/icons/foundry-logo.svg";
import { ReactComponent as MorphLogo } from "../../assets/icons/morph-logo-v3.svg";
import { useHistory } from "react-router-dom";
import useSecurity from "../../hooks/useSecurity";
import { RequestContext } from "../../context/RequestContext";
import { DashboardContext } from "../../context/DashboardContext";
import _ from "lodash";
import { AlertMessage } from "../../constants/AlertMessage";
import AlertDialog from "../common/AlertDialog";
import DashboardMode from "../../constants/DashboardMode";
import { addItem } from "../../utils/AppLocalStorage";
import { ConfigContext } from "../../security/ConfigContext";
import { UserContext } from "../../context/UserContext";
import "./headerNav.scss";
import { HeaderTabs } from "../../constants/HeaderNav";
import Banners from "../banners/Banners";
import { BannerContext } from "../../context/BannerContext";

export default function MenuAppBar() {
  const history = useHistory();
  const config = useContext(ConfigContext);
  const [isAlert, setAlert] = useState(false);
  const { authService, userInfo } = useSecurity();
  const { sources, draftSaved, requestDraft, status } =
    useContext(RequestContext);
  const { _setDashboardView } = useContext(DashboardContext);
  const { userRole } = useContext(UserContext);
  const { isDraftSaved } = AlertMessage;
  const [selectedItem, setSelectedItem] = useState({})
  const {banners} = useContext(BannerContext);
  const logout = async () => authService && authService.signOut();

  const handleChange = (item) => {
    if (item.id === "help" || item.id === "okta") {
      const url = item.id === "okta" ? config[0].oidc.adminOktaPage : item.href;
      window.open(url, "_blank");
    } else if (item.id === "job" || item.id === "request") {
      const userId = _.get(userInfo, "sAMAccountName");
      const key = "dashboardView";
      const value =
        item.id === "job" ? DashboardMode.JOBS : DashboardMode.REQUESTS;
      addItem(userId, key, value);
      _setDashboardView(value);
      history.push(item.href);
    } else if (item.id === "logout") {
      logout();
    } else {
      history.push(item.href);
    }
  };

  return (
    <div>
      <AppBar position="fixed" classes={{ colorPrimary: "nav-bar" }}>
        {banners.length > 0 && <Banners banners={banners} />}
        <Toolbar classes={{ regular: "toolbar" }}>
          <div className="logo-container">
            <span className="foundry-logo">
              <FoundryLogo />
            </span>
            <span className="morph-logo">
              <MorphLogo />
            </span>
          </div>
          <div className="link-container">
            {HeaderTabs.map((item, index) => {
              const obj = {
                className: "nav-bar-link",
                id: item.id,
                key: `${item.id}-${index}`,
                onClick: (e) => {
                  if (
                    _.size(sources) > 0 &&
                    !draftSaved &&
                    status === "DRAFT" && !(item.id === "help" || item.id === "okta")
                  ) {
                    setAlert(true);
                  } else {
                    handleChange(item);
                  }
                  setSelectedItem(item);
                },
              };
              return (
                item.permittedRoles.find((role) => role === userRole) && (
                  <>
                    <a {...obj}>{item.label} </a>
                    {item.id === "help" && (<Tooltip
                      title="The Help site is only accessible from WBD internal networks."
                      interactive
                      arrow
                      placement="bottom"
                    >
                      <Info className="helpInfoIcon" />
                    </Tooltip>)}
                  </>
                )
              );
            })}
          </div>
        </Toolbar>
      </AppBar>
      <AlertDialog
        alertMessage={isDraftSaved}
        isAlert={isAlert}
        onClose={(type) => {
          if (type === "close") {
            setSelectedItem({});
            setAlert(false);
          }
        }}
        onCancel={() => {
          handleChange(selectedItem);
        }}
        onConfirm={() => {
          requestDraft();
          handleChange(selectedItem);
          setAlert(false);
        }}
      />
    </div>
  );
}
